import type { Branded } from '../types';

export type PolicyScopeType = 'apiScopes' | 'attributeScopes';

export type PolicyBase = {
  name: string;
  description: string;
  isSystem: boolean;
  scopeType: PolicyScopeType;
};

export type PolicyId = Branded<string, 'policyId'>;

export type PolicyBaseWithId = PolicyBase & {
  id: PolicyId;
};
